import { render, staticRenderFns } from "./personalize-section.vue?vue&type=template&id=5d5871b0&scoped=true&"
import script from "./personalize-section.vue?vue&type=script&lang=js&"
export * from "./personalize-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5871b0",
  null
  
)

export default component.exports